/* eslint-disable no-unused-expressions */
import React from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const HomeBanner = () => {
  const { bannerApi } = apiPath;
  const [homeBannerData, homeBannerLoading] = useFetch(bannerApi);
  if (homeBannerLoading) {
    return <Loading />;
  }

  const {
    sideBarTitle,
    sideBarLinks,
    phoneNumber,
    email,
    bannerSlogan,
    bannerButtonName,
    bannerImages,
  } = homeBannerData;

  const imagesData = [];
  bannerImages.map((item, index) => {
    imagesData.push({
      label: `Banner Image ${index}`,
      type: "file",
      name: "",
      defaultValue: item,
    });
  });

  const sidebarLinksData = [];
  sideBarLinks.map((item, index) => {
    sidebarLinksData.push({
      label: `SideBar Links ${index}`,
      type: "text",
      name: "",
      defaultValue: item,
    });
  });

  const bannerButtons = [];
  bannerButtonName.map((item, index) => {
    bannerButtons.push({
      label: `Banner Button ${index}`,
      type: "text",
      name: "",
      defaultValue: item,
    });
  });

  const data = [
    {
      elementType: "input",
      label: "Banner Title",
      type: "Text",
      name: "sideBarTitle",
      defaultValue: sideBarTitle,
      required: false,
    },
    // {
    //   elementType: "input",
    //   label: "Phone Number",
    //   type: "Text",
    //   name: "phoneNumber",
    //   defaultValue: phoneNumber,
    //   required: false,
    // },
    // {
    //   elementType: "input",
    //   label: "Email",
    //   type: "email",
    //   name: "email",
    //   defaultValue: email,
    //   required: false,
    // },
    {
      elementType: "textField",
      label: "Banner Slogan",
      type: "Text",
      name: "bannerSlogan",
      defaultValue: bannerSlogan,
      required: false,
    },
  ];

  const nestedData = [
    {
      elementType: "file",
      label: "Banner Image",
      name: "bannerImages",
      multipleData: imagesData,
      multiple: true,
      required: false,
    },
  ];

  const multiDimensionalData = [
    // {
    //   elementType: "nested",
    //   label: "Side Bar Links",
    //   name: "sideBarLinks",
    //   multipleData: sidebarLinksData,
    //   multiple: true,
    //   required: false,
    // },
  ];

  const multiDimensionalDataText = [
    // {
    //   elementType: "nestedText",
    //   label: "Banner Buttons",
    //   name: "bannerButtonName",
    //   multipleData: bannerButtons,
    //   multiple: true,
    //   required: false,
    // },
  ];

  const useData = data.concat(
    nestedData,
    multiDimensionalData,
    multiDimensionalDataText
  );

  const update = (data) => {
    updateData(bannerApi, data);
  };

  return (
    <div>
      <GlobalForm
        data={useData}
        nestedData={nestedData}
        multiDimensionalData={multiDimensionalData}
        multiDimensionalDataText={multiDimensionalDataText}
        update={update}
      />
    </div>
  );
};

export default HomeBanner;
